import IConfigBehaviour from './Interfaces/IConfigBehaviour';

class ConfigBehaviour implements IConfigBehaviour {
    public autoplay = true;
    public tabIndex = 999;
    public fullscreenElement: HTMLElement = null;
    public fallbackImageUrl = '';
}

export default ConfigBehaviour;
